// Lazy Stimulus-controller registry for the public portal bundle.
// Each entry maps a Stimulus controller identifier to a thunk that
// dynamically imports the controller module. application_portal.js
// passes this registry to bootLazyControllers, which scans the page
// for [data-controller] tokens and loads only what's actually present.
//
// The dynamic import() calls are what trigger esbuild's --splitting
// to emit each controller as its own chunk, so the initial bundle
// only ships eager controllers + bootstrapping logic.
export const lazyControllers = {
  "wheel":                     () => import("./wheel_controller"),
  "wheel-promo":               () => import("./wheel_promo_controller"),
  "share-chart":               () => import("./share_chart_controller"),
  "share-track":               () => import("./share_track_controller"),
  "share-image-status":        () => import("./share_image_status_controller"),
  "quiz-builder":              () => import("./quiz_builder_controller"),
  "quiz-answers":              () => import("./quiz_answers_controller"),
  "quiz-rating":               () => import("./quiz_rating_controller"),
  "comments":                  () => import("./comments_controller"),
  "leaderboard-animate":       () => import("./leaderboard_animate_controller"),
  "points-fly":                () => import("./points_fly_controller"),
  "points-popup":              () => import("./points_popup_controller"),
  "rank-up-popup":             () => import("./rank_up_popup_controller"),
  "push-notification":         () => import("./push_notification_controller"),
  "carousel":                  () => import("./carousel_controller"),
  "auto-carousel":             () => import("./auto_carousel_controller"),
  "avatar-upload":             () => import("./avatar_upload_controller"),
  "internal-ad":               () => import("./internal_ad_controller"),
  "ads":                       () => import("./ads_controller"),
  "adsense-fallback":          () => import("./adsense_fallback_controller"),
  "trivia-question":           () => import("./trivia_question_controller"),
  "cps":                       () => import("./cps_controller"),
  "pin-button":                () => import("./pin_button_controller"),
  "editor-feedback":           () => import("./editor_feedback_controller"),
  "new-quiz":                  () => import("./new_quiz_controller"),
  "topic-suggest":             () => import("./topic_suggest_controller"),
  "topic-board":               () => import("./topic_board_controller"),
  "creator-exit-survey":       () => import("./creator_exit_survey_controller"),
  "notification-bell":         () => import("./notification_bell_controller"),
  "viral-focus":               () => import("./viral_focus_controller"),
  "up-next":                   () => import("./up_next_controller"),
  "embed-copy":                () => import("./embed_copy_controller"),
  "shop-confirm":              () => import("./shop_confirm_controller"),
  "daily-streak-modal":        () => import("./daily_streak_modal_controller"),
  "cosmetic-picker":           () => import("./cosmetic_picker_controller"),
  "streak-chest":              () => import("./streak_chest_controller"),
  "streak-double":             () => import("./streak_double_controller"),
  "shop-ticker":               () => import("./shop_ticker_controller"),
  "wheel-share-pin":           () => import("./wheel_share_pin_controller"),
  "pet-feed":                  () => import("./pet_feed_controller"),
}
